import { all } from "redux-saga/effects";

export default function* root() {
  try {
    yield all([]);
  } catch (error) {
    console.log("Error at root Saga");
  }
}
